import React, { useEffect, useState } from "react";
import { Postrequestcall } from "../../request/Postrequest";
import {
  FETCH_COMPANIES_2,
  FETCH_COMPANIES_WITH_FOLLOW_STATUS,
  SEARCH_COMPANIES_NEW
} from "../../constant/Apipath";
import { useSelector } from "react-redux";

const PAGE_SIZE = 20;
import {
  Avatar,
  Box,
  Button,
  Card,
  Chip,
  FormControlLabel,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Tab,
  Tabs,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import SearchField from "../common/SearchField";
import { BIBlue, BIRed, lightenHexColor } from "../../assets/helpers";
import Loader from "../../common/Loader";
import { MoreVert as MoreIcon } from "@mui/icons-material";
import VerifiedIcon from "@mui/icons-material/Verified";
import WarningIcon from "@mui/icons-material/Warning";
import FilterListIcon from "@mui/icons-material/FilterList";
import CancelIcon from "@mui/icons-material/Cancel";
import BusinessIcon from "@mui/icons-material/Business";
import FactoryIcon from "@mui/icons-material/Factory";
import ConstructionIcon from "@mui/icons-material/Construction";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CompanyListFilterModal from "./CompanyListFilterModal";
import InfiniteScroll from "react-infinite-scroll-component";
import AddCompanyModal from "../common/AddCompanyModal";
import UseDebounce from "../common/UseDebounce";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setShowReport } from "../../redux/actions/actions";
import Pageheader from "../common/Pageheader";
import Emptydata from "../common/Emptydata";
import { AddButton } from "../common/AddButton";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { English } from "../../constant/EnglishFallback";
import Pages from "../../constant/ReportModel";
import { CompaniesSkeleton } from "../skeleton/SkeletonView";
import AdContainer from "../common/AdContainer";

const Companies = () => {
  const { loginData, reportSuccess } = useSelector((state) => state?.main);
  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.Companies || {};

  const {
    TEXT_COMPANY_PROFILES = English.Companies.TEXT_COMPANY_PROFILES || "Company and Manufacturer Listing",
    TEXT_SEARCH_COMPANY = English.Companies.TEXT_SEARCH_COMPANY,
    TEXT_RESULTS = English.Companies.TEXT_RESULTS,
    NO_RESULT = English.Companies.NO_RESULT,
    BUTTON_REPORT = English.Companies.BUTTON_REPORT,
    TEXT_ADD_COMPANY = English.Companies.TEXT_ADD_COMPANY
  } = LanguageData || {};

  let navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [nrOfRecords, setNrOfRecords] = useState(0);
  const [searchTerm, setSearchTerm] = useState(location?.state?.searchTerm || "");
  const [companyTypeFilter, setCompanyTypeFilter] = useState(
    location?.state?.isManufacturer ? "manufacturers" : "all"
  );
  const [selectedTrade, setSelectedTrade] = useState(null);
  const [address, setAddress] = useState("");
  const [addressDetails, setAddressDetails] = useState(null);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const abortControllerRef = React.useRef(null);

  const activeFilterCount =
    (companyTypeFilter !== "all" ? 1 : 0) +
    (selectedTrade ? 1 : 0) +
    (address?.trim() ? 1 : 0);

  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [pageNr, setPageNr] = useState(1);
  const [showAddItemModal, setShowAddItemModal] = useState(false);
  const [recordId, setRecordId] = useState([]);
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const [activeTab, setActiveTab] = useState("all");

  const getFirstTabLabel = () => {
    if (companyTypeFilter === "manufacturers") return "All Manufacturers";
    if (companyTypeFilter === "companies") return "Companies";
    return "All Companies";
  };

  const getSecondTabLabel = () => {
    if (companyTypeFilter === "all") return "All My Followings";
    return "My Following";
  };

  const companyTabs = [
    { value: "all", label: getFirstTabLabel() },
    { value: "following", label: getSecondTabLabel() }
  ];

  const debouncedSearchTerm = UseDebounce(searchTerm, 400);
  const isFirstMount = React.useRef(true);

  useEffect(() => {
    if (isFirstMount.current) {
      isFirstMount.current = false;
      getData("", 1, activeTab, companyTypeFilter, selectedTrade, address, addressDetails);
      return;
    }
    setPageNr(1);
    setData([]);
    setNrOfRecords(0);
    getData(debouncedSearchTerm, 1, activeTab, companyTypeFilter, selectedTrade, address, addressDetails);
  }, [debouncedSearchTerm]);

  useEffect(() => {
    if (reportSuccess === true) {
      getData(debouncedSearchTerm, 1, activeTab, companyTypeFilter, selectedTrade, address, addressDetails);
    }
  }, [reportSuccess]);

  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  const getData = async (
    currentSearchTerm = searchTerm,
    pageNo = 1,
    tabValue = activeTab,
    typeFilter = companyTypeFilter,
    tradeFilter = selectedTrade,
    addressFilter = address,
    addressDetailsFilter = addressDetails
  ) => {
    try {
      if (pageNo === 1) {
        setIsLoading(true);
      }
      setAllDataLoaded(true);

      // Cancel previous in-flight request if any
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      abortControllerRef.current = new AbortController();

      const isFollowingTab = tabValue === "following";
      let res;
      let resData = [];
      let totalRecords = 0;

      const tradeId = tradeFilter?.id ?? tradeFilter?.value;
      const cleanAddress = (addressFilter || "").trim();

      if (isFollowingTab) {
        const obj = {
          UserId: loginData?.userInformation?.UserId ?? loginData?.userInformation?.userId ?? 2596,
          SearchString: currentSearchTerm ?? "",
          FullSearch: "",
          PageNumber: pageNo,
          PageSize: PAGE_SIZE || 25,
          Manufacturer:
            typeFilter === "manufacturers"
              ? true
              : typeFilter === "companies"
              ? false
              : null,
          TradeId: tradeId !== undefined && tradeId !== null ? (Number(tradeId) || tradeId) : null,
          Address: cleanAddress || "",
          City: addressDetailsFilter?.city?.trim() || "",
          Province: (addressDetailsFilter?.province_long || addressDetailsFilter?.province || "").trim(),
          PostalCode: addressDetailsFilter?.postalCode?.trim() || "",
          Country: addressDetailsFilter?.country?.trim() || "",
          Verified: null,
          FetchAllowedRecordsOnly: true,
          IsFollowing: true,
          IncludeRecordNr: true,
          SortField: "Name",
          SortDirection: "ASC"
        };

        res = await Postrequestcall(
          FETCH_COMPANIES_WITH_FOLLOW_STATUS,
          obj,
          loginData?.accessToken
        );
      } else {
        const searchItem = {};
        if (typeFilter === "manufacturers") {
          searchItem.manufacturer = true;
        } else if (typeFilter === "companies") {
          searchItem.manufacturer = false;
        }
        if (tradeId !== undefined && tradeId !== null) {
          const num = Number(tradeId);
          searchItem.tradeId = !isNaN(num) ? num : tradeId;
        }
        if (cleanAddress) {
          searchItem.address = cleanAddress;
        }
        if (addressDetailsFilter?.city) {
          searchItem.city = addressDetailsFilter.city.trim();
        }
        if (addressDetailsFilter?.province || addressDetailsFilter?.province_long) {
          searchItem.province = (addressDetailsFilter.province_long || addressDetailsFilter.province).trim();
        }
        if (addressDetailsFilter?.postalCode) {
          searchItem.postalCode = addressDetailsFilter.postalCode.trim();
        }
        if (addressDetailsFilter?.country) {
          searchItem.country = addressDetailsFilter.country.trim();
        }
        if (addressDetailsFilter?.latitude && addressDetailsFilter?.longitude) {
          searchItem.latitude = addressDetailsFilter.latitude;
          searchItem.longitude = addressDetailsFilter.longitude;
        }

        const hasSearchItem = Object.keys(searchItem).length > 0;
        const searchList = hasSearchItem ? [searchItem] : [{}];

        const payload = {
          PageNr: pageNo,
          NrOfRecPerPage: PAGE_SIZE,
          FullSearch: currentSearchTerm?.trim() || "",
          UserId: loginData?.userInformation?.UserId ?? loginData?.userInformation?.userId ?? 1,
          IncludeRecordNr: true,
          FetchAllowedRecordsOnly: true,
          SearchList: searchList,
          SortList: [
            {
              FieldName: "Name",
              Direction: "ASC"
            }
          ]
        };

        res = await Postrequestcall(
          SEARCH_COMPANIES_NEW,
          payload,
          loginData?.accessToken
        );
      }

      resData = Array.isArray(res?.data?.data)
        ? res.data.data
        : Array.isArray(res?.data?.dataList)
        ? res.data.dataList
        : Array.isArray(res?.data)
        ? res.data
        : [];

      totalRecords = Number(
        res?.data?.nrOfRecords ??
        res?.data?.RecordNr ??
        res?.data?.totalRecords ??
        res?.nrOfRecords ??
        res?.RecordNr ??
        res?.totalRecords ??
        resData.length ??
        0
      );

      if (pageNo === 1) {
        setData(resData);
      } else {
        setData((prevData) => {
          const seen = new Set(prevData.map((p) => p.id || p.Id || p.companyId || p.CompanyId));
          const fresh = resData.filter((p) => !seen.has(p.id || p.Id || p.companyId || p.CompanyId));
          return [...prevData, ...fresh];
        });
      }
      setNrOfRecords(totalRecords);
      setAllDataLoaded(false);
      setIsLoading(false);
    } catch (error) {
      if (error?.name !== "CanceledError" && error?.name !== "AbortError") {
        console.log("getData-> Error When fetching Companies: ", error);
      }
      setAllDataLoaded(false);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
      setAllDataLoaded(false);
    }
  };

  const handleApplyFilters = ({
    companyType,
    selectedTrade: trade,
    address: addr,
    addressDetails: addrDetails
  }) => {
    setCompanyTypeFilter(companyType);
    setSelectedTrade(trade);
    setAddress(addr);
    setAddressDetails(addrDetails);
    setPageNr(1);
    setData([]);
    setNrOfRecords(0);
    getData(searchTerm, 1, activeTab, companyType, trade, addr, addrDetails);
  };

  const handleRemoveFilter = (filterKey) => {
    let nextType = companyTypeFilter;
    let nextTrade = selectedTrade;
    let nextAddr = address;
    let nextAddrDetails = addressDetails;

    if (filterKey === "type") {
      nextType = "all";
      setCompanyTypeFilter("all");
    } else if (filterKey === "trade") {
      nextTrade = null;
      setSelectedTrade(null);
    } else if (filterKey === "address") {
      nextAddr = "";
      nextAddrDetails = null;
      setAddress("");
      setAddressDetails(null);
    }

    setPageNr(1);
    setData([]);
    setNrOfRecords(0);
    getData(
      searchTerm,
      1,
      activeTab,
      nextType,
      nextTrade,
      nextAddr,
      nextAddrDetails
    );
  };

  const handleClearAllFilters = () => {
    setCompanyTypeFilter("all");
    setSelectedTrade(null);
    setAddress("");
    setAddressDetails(null);
    setPageNr(1);
    setData([]);
    setNrOfRecords(0);
    getData(searchTerm, 1, activeTab, "all", null, "", null);
  };

  const getAddress = (item) => {
    return [
      item?.address || item?.Address,
      item?.city || item?.City,
      item?.province || item?.Province,
      item?.postalCode || item?.PostalCode,
      item?.country || item?.Country
    ]
      .filter(Boolean)
      .join(", ");
  };

  const handleMenuOpen = (event, item) => {
    event.stopPropagation();
    setMoreMenuAnchorEl(event.currentTarget);
    setSelectedItem(item);
  };

  const onCompanyClick = (item) => {
    if (item?.recordStatusId === 3) {
      alert("This company is reported");
      return;
    }
    const companyId = item?.id || item?.Id || item?.companyId || item?.CompanyId;
    if (item?.manufacturer) {
      navigate(`/manufacture/${companyId}`);
    } else {
      navigate(`/company/${companyId}`);
    }
  };

  const handleViewReport = () => {
    setMoreMenuAnchorEl(null);

    // When the item in Companies list is actually a manufacturer,
    // report it using the same application/screen as the Manufacturers page.
    const isManufacturer = !!recordId?.manufacturer;

    let reportObj = {
      showReport: true,
      name: isManufacturer ? Pages?.manufacturers?.name : Pages?.companies?.name,
      AppScreenId: isManufacturer ? Pages?.manufacturers?.id : Pages?.companies?.id,
      recordId: recordId.id ?? 0,
      isVerified: !!recordId?.verified
    };
    dispatch(setShowReport(reportObj));
  };

  const handleSearchChange = (value) => {
    setSearchTerm(value);
    // Manual search only - user must click the search icon or press Enter
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setPageNr(1);
    setData([]);
    setNrOfRecords(0);
    getData(
      searchTerm,
      1,
      newValue,
      companyTypeFilter,
      selectedTrade,
      address,
      addressDetails
    );
  };

  const handleLoadMore = async () => {
    if (data.length < nrOfRecords) {
      const nextPage = pageNr + 1;
      await getData(
        searchTerm,
        nextPage,
        activeTab,
        companyTypeFilter,
        selectedTrade,
        address,
        addressDetails
      );
      setPageNr(nextPage);
    }
  };

  const handleAddPostClick = (event) => {
    event.target.blur();
    setShowAddItemModal(true);
  };

  const handleMenuClose = () => setMoreMenuAnchorEl(null);

  const getSearchPlaceholder = () => {
    if (companyTypeFilter === "manufacturers") {
      return (
        multiLanguageData?.Manufacturers?.TEXT_SEARCH_MANUFACTURERS ||
        English?.Manufacturers?.TEXT_SEARCH_MANUFACTURERS ||
        "Search manufacturers"
      );
    }
    if (companyTypeFilter === "companies") {
      return TEXT_SEARCH_COMPANY || "Search companies";
    }
    return "Search companies and manufacturers";
  };

  return (
    <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3, pt: 2 }}>
      <Pageheader headerName={TEXT_COMPANY_PROFILES} />
      <Card className="main-content-card">
        <Grid
          sx={{
            pb: 1.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
          }}
          container
          spacing={1}
        >
          <Grid size={{ xs: 12, sm: 8, md: 6, lg: 5 }}>
            <Stack
              direction="row"
              spacing={1}
              sx={{ width: "100%", alignItems: "center" }}
            >
              <Box sx={{ flex: 1 }}>
                <SearchField
                  size={"small"}
                  value={searchTerm}
                  onChange={handleSearchChange}
                  onSubmit={() =>
                    getData(
                      searchTerm,
                      1,
                      activeTab,
                      companyTypeFilter,
                      selectedTrade,
                      address,
                      addressDetails
                    )
                  }
                  onClear={() => {
                    setSearchTerm("");
                    setPageNr(1);
                    getData(
                      "",
                      1,
                      activeTab,
                      companyTypeFilter,
                      selectedTrade,
                      address,
                      addressDetails
                    );
                  }}
                  searchIconOutside
                  placeholder={getSearchPlaceholder()}
                />
              </Box>
              <Button
                variant={activeFilterCount > 0 ? "contained" : "outlined"}
                startIcon={<FilterListIcon />}
                endIcon={
                  activeFilterCount > 0 ? (
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClearAllFilters();
                      }}
                      sx={{ p: 0.2, color: "inherit", ml: 0.2 }}
                    >
                      <CancelIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                  ) : null
                }
                onClick={() => setShowFilterModal(true)}
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "0.82rem",
                  borderRadius: 2,
                  height: 38,
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                  ...(activeFilterCount > 0
                    ? {
                        bgcolor: BIBlue,
                        color: "#fff",
                        "&:hover": { bgcolor: BIBlue }
                      }
                    : {
                        borderColor: "#d0d0d0",
                        color: "text.primary"
                      })
                }}
              >
                {activeFilterCount > 0
                  ? `Filters (${activeFilterCount})`
                  : "Filter"}
              </Button>
            </Stack>
          </Grid>
          <Grid
            sx={{
              display: "flex",
              justifyContent: { xs: "flex-start", md: "flex-end" }
            }}
            size={{ xs: 12, sm: 4, md: 3, lg: 2 }}
          >
            <Typography variant="h6" sx={{ color: "text.secondary" }}>
              {nrOfRecords} {TEXT_RESULTS}
            </Typography>
          </Grid>
        </Grid>

        {/* Active Filter Chips Row */}
        {activeFilterCount > 0 && (
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            flexWrap="wrap"
            sx={{ mb: 1.5, gap: 1 }}
          >
            {companyTypeFilter !== "all" && (
              <Chip
                icon={
                  companyTypeFilter === "manufacturers" ? (
                    <FactoryIcon sx={{ fontSize: "16px !important", color: `${BIBlue} !important` }} />
                  ) : (
                    <BusinessIcon sx={{ fontSize: "16px !important", color: `${BIBlue} !important` }} />
                  )
                }
                label={
                  companyTypeFilter === "manufacturers"
                    ? "Manufacturers"
                    : "Companies"
                }
                onDelete={() => handleRemoveFilter("type")}
                size="small"
                sx={{
                  bgcolor: lightenHexColor(BIBlue, 92),
                  color: BIBlue,
                  fontWeight: 600,
                  borderColor: lightenHexColor(BIBlue, 70),
                  "& .MuiChip-icon": { color: BIBlue },
                  "& .MuiChip-deleteIcon": { color: BIBlue }
                }}
                variant="outlined"
              />
            )}
            {selectedTrade && (
              <Chip
                icon={<ConstructionIcon sx={{ fontSize: "16px !important", color: `${BIBlue} !important` }} />}
                label={selectedTrade.label || selectedTrade.name}
                onDelete={() => handleRemoveFilter("trade")}
                size="small"
                sx={{
                  bgcolor: lightenHexColor(BIBlue, 92),
                  color: BIBlue,
                  fontWeight: 600,
                  borderColor: lightenHexColor(BIBlue, 70),
                  "& .MuiChip-icon": { color: BIBlue },
                  "& .MuiChip-deleteIcon": { color: BIBlue }
                }}
                variant="outlined"
              />
            )}
            {address && (
              <Chip
                icon={<LocationOnIcon sx={{ fontSize: "16px !important", color: `${BIBlue} !important` }} />}
                label={address}
                onDelete={() => handleRemoveFilter("address")}
                size="small"
                sx={{
                  bgcolor: lightenHexColor(BIBlue, 92),
                  color: BIBlue,
                  fontWeight: 600,
                  borderColor: lightenHexColor(BIBlue, 70),
                  "& .MuiChip-icon": { color: BIBlue },
                  "& .MuiChip-deleteIcon": { color: BIBlue }
                }}
                variant="outlined"
              />
            )}
            <Button
              size="small"
              variant="text"
              onClick={handleClearAllFilters}
              sx={{
                textTransform: "none",
                fontSize: "0.78rem",
                color: "text.secondary",
                fontWeight: 600,
                minWidth: "auto",
                p: 0.5
              }}
            >
              Clear all
            </Button>
          </Stack>
        )}

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: 1,
            borderColor: "divider",
            mb: 1,
            flexWrap: "wrap",
            gap: 1
          }}
        >
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons={false}
          >
            {companyTabs.map((tab) => (
              <Tab key={tab.value} value={tab.value} label={tab.label} />
            ))}
          </Tabs>

          <Box sx={{ mr: 1, my: 0.5 }}>
            <ToggleButtonGroup
              size="small"
              value={companyTypeFilter}
              exclusive
              onChange={(e, val) => {
                if (val !== null) {
                  setCompanyTypeFilter(val);
                  setPageNr(1);
                  setData([]);
                  setNrOfRecords(0);
                  const nextTab = val === "all" ? "all" : activeTab;
                  if (val === "all" && activeTab !== "all") {
                    setActiveTab("all");
                  }
                  getData(
                    searchTerm,
                    1,
                    nextTab,
                    val,
                    selectedTrade,
                    address,
                    addressDetails
                  );
                }
              }}
              sx={{
                "& .MuiToggleButton-root": {
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "0.78rem",
                  px: 1.5,
                  py: 0.4,
                  borderColor: "divider",
                  "&.Mui-selected": {
                    bgcolor: "primary.main",
                    color: "white",
                    "&:hover": { bgcolor: "primary.dark" }
                  }
                }
              }}
            >
              <ToggleButton value="all">All</ToggleButton>
              <ToggleButton value="companies">Companies</ToggleButton>
              <ToggleButton value="manufacturers">Manufacturers</ToggleButton>
            </ToggleButtonGroup>
          </Box>
        </Box>
        {isLoading ? (
          <>
            <CompaniesSkeleton />
          </>
        ) : (
          <>
            <Box className="main-content-card-list" id="scrollablediv_prodcut">
              {data.length !== 0 ? (
                <InfiniteScroll
                  dataLength={data?.length}
                  next={handleLoadMore}
                  hasMore={data.length < nrOfRecords}
                  loader={
                    !allDataLoaded ? null : (
                      <h4 style={{ display: "flex", justifyContent: "center" }}>
                        <Loader />
                      </h4>
                    )
                  }
                  scrollableTarget="scrollablediv_prodcut">
                  <List disablePadding>
                    <Stack sx={{ gap: 1.5 }}>
                      {data?.map((item, index) => {
                        const isReported = item?.recordStatusId === 3;
                        const isMfr = Boolean(item?.manufacturer);
                        const fullAddr = getAddress(item);
                        const companyName = item?.name || "Unnamed Company";

                        return (
                          <Card
                            key={item?.id || item?.Id || item?.companyId || item?.CompanyId || index}
                            onClick={() => {
                              if (isReported) {
                                alert(isMfr ? "This manufacturer is reported" : "This company is reported");
                                return;
                              }
                              onCompanyClick(item);
                            }}
                            sx={{
                              p: 1.75,
                              borderRadius: "14px",
                              border: "1px solid #eef2f6",
                              boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
                              opacity: isReported ? 0.6 : 1,
                              cursor: isReported ? "not-allowed" : "pointer",
                              transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                              "&:hover": {
                                transform: isReported ? "none" : "translateY(-2px)",
                                boxShadow: isReported ? "none" : "0 8px 20px rgba(15, 23, 42, 0.08)",
                                borderColor: lightenHexColor(BIBlue, 75)
                              }
                            }}
                          >
                            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.75 }}>
                              {/* Avatar / Logo */}
                              <Avatar
                                src={item?.imageUrl || item?.logoUrl || item?.thumbImageUrl}
                                alt={companyName}
                                variant="rounded"
                                sx={{
                                  width: 48,
                                  height: 48,
                                  borderRadius: "12px",
                                  bgcolor: isMfr ? "#fef3c7" : lightenHexColor(BIBlue, 92),
                                  color: isMfr ? "#b45309" : BIBlue,
                                  border: `1px solid ${isMfr ? "#fde68a" : lightenHexColor(BIBlue, 80)}`,
                                  flexShrink: 0
                                }}
                              >
                                {isMfr ? <FactoryIcon sx={{ fontSize: 24 }} /> : <BusinessIcon sx={{ fontSize: 24 }} />}
                              </Avatar>

                              {/* Content Details */}
                              <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Stack direction="row" alignItems="center" spacing={0.75} sx={{ mb: 0.5 }}>
                                  <Typography
                                    variant="subtitle1"
                                    sx={{
                                      fontWeight: 700,
                                      color: "#1e293b",
                                      fontSize: "0.95rem",
                                      lineHeight: 1.3
                                    }}
                                    noWrap
                                  >
                                    {companyName}
                                  </Typography>
                                  {item?.verified && (
                                    <Tooltip title="Verified Business" arrow>
                                      <VerifiedIcon sx={{ color: BIBlue, fontSize: "1.1rem", flexShrink: 0 }} />
                                    </Tooltip>
                                  )}
                                </Stack>

                                {/* Location Address */}
                                {fullAddr && (
                                  <Stack direction="row" alignItems="center" spacing={0.5} sx={{ mt: 0.5 }}>
                                    <LocationOnIcon sx={{ fontSize: 15, color: "#64748b", flexShrink: 0 }} />
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        color: "#64748b",
                                        fontSize: "0.82rem",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap"
                                      }}
                                    >
                                      {fullAddr}
                                    </Typography>
                                  </Stack>
                                )}
                              </Box>

                              {/* Right Actions & Tag */}
                              <Stack direction="row" spacing={1} alignItems="center" sx={{ flexShrink: 0, ml: 1 }}>
                                {isMfr ? (
                                  <Chip
                                    icon={<FactoryIcon sx={{ fontSize: "14px !important", color: "#b45309 !important" }} />}
                                    label="Manufacturer"
                                    size="small"
                                    sx={{
                                      height: 24,
                                      fontSize: "0.72rem",
                                      fontWeight: 600,
                                      bgcolor: "#fef3c7",
                                      color: "#b45309",
                                      border: "1px solid #fde68a",
                                      borderRadius: "6px"
                                    }}
                                  />
                                ) : (
                                  <Chip
                                    icon={<BusinessIcon sx={{ fontSize: "14px !important", color: `${BIBlue} !important` }} />}
                                    label="Company"
                                    size="small"
                                    sx={{
                                      height: 24,
                                      fontSize: "0.72rem",
                                      fontWeight: 600,
                                      bgcolor: lightenHexColor(BIBlue, 92),
                                      color: BIBlue,
                                      border: `1px solid ${lightenHexColor(BIBlue, 75)}`,
                                      borderRadius: "6px"
                                    }}
                                  />
                                )}
                                {isReported && (
                                  <Tooltip title="This listing has been reported" arrow>
                                    <WarningIcon
                                      sx={{ color: "error.main", fontSize: "1.2rem", cursor: "pointer" }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        alert(isMfr ? "This manufacturer is reported" : "This company is reported");
                                      }}
                                    />
                                  </Tooltip>
                                )}
                                <IconButton
                                  size="small"
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    handleMenuOpen(event, item);
                                    setRecordId(item);
                                  }}
                                  sx={{
                                    color: "#64748b",
                                    "&:hover": { bgcolor: "#f1f5f9", color: "#1e293b" }
                                  }}
                                >
                                  <MoreIcon fontSize="small" />
                                </IconButton>
                                <ChevronRightIcon
                                  sx={{
                                    color: "#94a3b8",
                                    fontSize: 20,
                                    transition: "transform 0.2s",
                                    "&:hover": { transform: "translateX(2px)" }
                                  }}
                                />
                              </Stack>
                            </Box>
                          </Card>
                        );
                      })}
                    </Stack>
                  </List>
                </InfiniteScroll>
              ) : (
                <Box className="empty-data-card">
                  <Emptydata
                    icon={<BusinessCenterIcon className="emptydata-icon" />}
                    firstText={NO_RESULT}
                  />
                </Box>
              )}
            </Box>
          </>
        )}
        <AddButton toolTipText={TEXT_ADD_COMPANY} onAddClick={handleAddPostClick} />
        <AdContainer />
      </Card>
      {moreMenuAnchorEl && (
        <Menu
          anchorEl={moreMenuAnchorEl}
          open={Boolean(moreMenuAnchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}>
          <MenuItem style={{ color: BIRed }} dense onClick={() => handleViewReport()}>
            {BUTTON_REPORT}
          </MenuItem>
        </Menu>
      )}
      {showAddItemModal && (
        <AddCompanyModal
          open={showAddItemModal}
          onClose={() => {
            setShowAddItemModal(false);
          }}
        />
      )}
      {showFilterModal && (
        <CompanyListFilterModal
          open={showFilterModal}
          onClose={() => setShowFilterModal(false)}
          initialFilters={{
            companyType: companyTypeFilter,
            selectedTrade,
            address,
            addressDetails
          }}
          onApplyFilters={handleApplyFilters}
        />
      )}
    </Box>
  );
};

export default Companies;

